<template>
  <div class="room-setting-chat-component p-5">
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{ $t("setting.chat.title") }}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">{{ $t("setting.chat.explain") }}</p>
      </div>
      <div class="room-setting-input-box">
        <label class="room-setting-label">
          <input  type="checkbox" name="useChat" class="room-setting-radio"
                  v-model="isChatMode"
                  @click="CHANGE_SETTING_DATA({ type:'useChat', value: !isChatMode})">
          <span>{{ $t("setting.chat.use") }}</span>
        </label>
      </div>
    </div>

    <div class="room-setting-content-box opacity-40 pointer-events-none">
      <h6 class="room-setting-content-title">{{ $t("setting.chat.participantList.title") }}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">{{ $t("setting.chat.participantList.description") }}</p>
      </div>
      <div class="room-setting-input-box">
        <label class="room-setting-label">
          <GrmSimpleSelect
              :value="participantListRoleId"
              :options="[
                    { value: 'participant', title: this.$t('setting.chat.participantList.select.participant') },
                    { value: 'speaker', title: this.$t('setting.chat.participantList.select.speaker') },
                    { value: 'emcee', title: this.$t('setting.chat.participantList.select.emcee') },
                  ]"
              @input="onChangeParticipantListRoleId"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import GrmSimpleSelect from "@/components/Common/select/GrmSimpleSelect.vue";

export default {
  components: {
    GrmSimpleSelect
  },
  data(){
    return{
      isChatMode: false
    }
  },
  computed:{
    ...mapGetters('roomSetting', [
        'params'
    ]),
    ...mapGetters('room', [
        'participantListRoleId'
    ]),
  },
  mounted(){
    this.isChatMode = this.params.useChat ? !this.isChatMode : this.isChatMode;
  },
  methods:{
    ...mapMutations('roomSetting', ['CHANGE_SETTING_DATA']),

    onChangeParticipantListRoleId(roleId) {
      console.log(roleId)
    }
  }
}
</script>